var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpPhoneAndDevicesNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-IP_Phone_and_Devices_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IP_Phone_and_Devices_Normal",
    "data-name": "IP Phone and Devices_Normal",
    clipPath: "url(#clip-IP_Phone_and_Devices_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IP_Phone_and_Devices",
    "data-name": "IP Phone and Devices",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_63",
    "data-name": "Subtraction 63",
    d: "M-636.06-772h-9.6a.6.6,0,0,1-.6-.6v-.009h-5.674v0a.6.6,0,0,1-.175.427.59.59,0,0,1-.422.175H-658.5a2.5,2.5,0,0,1-2.5-2.494v-20.445a2.5,2.5,0,0,1,2.5-2.494h.654v18.723a2.623,2.623,0,0,0,2.64,2.6h3.126a2.623,2.623,0,0,0,2.64-2.6v-18.723h13.38a2.5,2.5,0,0,1,2.5,2.494v20.445A2.5,2.5,0,0,1-636.06-772Zm-2.476-6.5a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-638.536-778.5Zm-3.793,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-642.329-778.5Zm-3.793,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-646.122-778.5Zm7.586-3.292a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-638.536-781.792Zm-3.793,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-642.329-781.792Zm-3.793,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-646.122-781.792Zm7.586-3.292a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-638.536-785.084Zm-3.793,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-642.329-785.084Zm-3.793,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-646.122-785.084Zm-1.669-9.313a.607.607,0,0,0-.607.607v6.115a.607.607,0,0,0,.607.607h10.909a.607.607,0,0,0,.607-.607v-6.115a.607.607,0,0,0-.607-.607Zm-4.289,17.091h-3.126a1.417,1.417,0,0,1-1.426-1.4v-18.723h5.978v18.723A1.417,1.417,0,0,1-652.08-777.307Z",
    transform: "translate(661.001 802)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4677",
    "data-name": "Path 4677",
    d: "M15.917,26.434H14.6a.607.607,0,1,1,0-1.214h1.32a.607.607,0,1,1,0,1.214Z",
    transform: "translate(-3.301 3.566)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129",
    transform: "translate(3.156 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 7.191,
    height: 24.675,
    rx: 1.56,
    transform: "translate(0.607 0.607)",
    fill: "#6f8b8f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpPhoneAndDevicesNormal);
export default __webpack_public_path__ + "static/media/IP_Phone_and Devices_Normal.b585c193ac94e8ade382ad9dd3fad9f2.svg";
export { ForwardRef as ReactComponent };